export var Size = {
    XS: 'xs',
    SM: 'sm',
    DEFAULT: 'default',
    LG: 'lg',
    XL: 'xl'
};
